import { ChannelsOverview } from "@/components/ChannelsOverview";
import { MetaStatements } from "@/components/MetaStatements";

export default function PanoramicaCanali() {
  return (
    <div className="space-y-8" data-testid="channels-overview-page">
      <div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-slate-900">Panoramica canali</h1>
        <p className="text-slate-500 mt-1">Tutti i tuoi numeri WhatsApp a colpo d'occhio: invii, consegne, clic, costi e quota del mese.</p>
      </div>
      <ChannelsOverview />
      <MetaStatements />
    </div>
  );
}
